import { gql } from 'graphql.macro';
import { deliveryOrdersFragment } from 'apollo/fragments';

export const DeliveryScheduleTemplate = gql`
    query deliverySchedule($deliveryScheduleInput: DeliveryScheduleInput!, $limit: Int, $offset: Int) {
        deliverySchedule(deliveryScheduleInput: $deliveryScheduleInput, limit: $limit, offset: $offset) {
            plannedOrders {
                ...deliveryOrdersFields
            }
            lateOrdersCount
            noDeadlineOrdersCount
        }
    }
    ${deliveryOrdersFragment}
`;

export const DeliveryScheduleLateOrdersTemplate = gql`
    query deliveryScheduleLateOrders(
        $isExternal: Boolean
        $limit: Int
        $offset: Int
        $sortBy: String
        $sortDirection: String
    ) {
        deliveryScheduleLateOrders(
            isExternal: $isExternal
            limit: $limit
            offset: $offset
            sortBy: $sortBy
            sortDirection: $sortDirection
        ) {
            ...deliveryOrdersFields
        }
    }
    ${deliveryOrdersFragment}
`;

export const DeliveryScheduleNoDeadlineOrdersTemplate = gql`
    query deliveryScheduleNoDeadlineOrders(
        $isExternal: Boolean
        $limit: Int
        $offset: Int
        $sortBy: String
        $sortDirection: String
    ) {
        deliveryScheduleNoDeadlineOrders(
            isExternal: $isExternal
            limit: $limit
            offset: $offset
            sortBy: $sortBy
            sortDirection: $sortDirection
        ) {
            ...deliveryOrdersFields
        }
    }
    ${deliveryOrdersFragment}
`;

// DD-3546: every order behind the "Print delivery notes" options for the day, sorted by
// clinic and order number. hasDeliveryNotePdf tells the user which ones cannot be merged.
export const DeliveryScheduleDeliveryNoteOrdersTemplate = gql`
    query deliveryScheduleDeliveryNoteOrders($deliveryNotesInput: DeliveryScheduleDeliveryNotesInput!) {
        deliveryScheduleDeliveryNoteOrders(deliveryNotesInput: $deliveryNotesInput) {
            _id
            orderId
            hasDeliveryNotePdf
        }
    }
`;
